import type { EditorTraining } from '~/shell/Store';

/** Mark that the course content was just edited by the user. */
export function touchContentEditedAt(training: EditorTraining): EditorTraining {
  return { ...training, contentEditedAt: new Date().toISOString() };
}

/** After publish: published snapshot matches current edited content. */
export function markTrainingPublished(
  training: EditorTraining
): EditorTraining {
  const at = training.contentEditedAt ?? new Date().toISOString();
  return { ...training, lastPublishedAt: at, contentEditedAt: at };
}

/** API / UI may use null, undefined, or "" for "never set" — treat as the same. */
export function normalizeContentTimestamp(
  value?: string | null
): string | null {
  if (value == null || value === '') {
    return null;
  }
  return value;
}

export function isTrainingContentInSync(training: EditorTraining): boolean {
  return (
    normalizeContentTimestamp(training.lastPublishedAt) ===
    normalizeContentTimestamp(training.contentEditedAt)
  );
}
